/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tea_Package_NewInputs */

const vi_tea_package_new = /** @type {(inputs: Tea_Package_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thêm gói chè`)
};

/**

* @param {Tea_Package_NewInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const tea_package_new = /** @type {((inputs?: Tea_Package_NewInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tea_Package_NewInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_tea_package_new(inputs)
});